import { render, staticRenderFns } from "./PropostasVinculadas.vue?vue&type=template&id=fc2d351c"
import script from "./PropostasVinculadas.vue?vue&type=script&lang=js"
export * from "./PropostasVinculadas.vue?vue&type=script&lang=js"
import style0 from "./PropostasVinculadas.vue?vue&type=style&index=0&id=fc2d351c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports